jQuery(document).ready(function ($) {
    'use strict';

    var hash = window.location.hash.substring(1, window.location.hash.length);

    if (window.location.hash) {

        setTimeout(function () {

            $('.filter-btn[data-cat*=' + hash + ']').trigger('click');

        }, 300);

    }

    $('.filter-btn').each(function () {

        $(this).on('click', function () {

            var items = $(this).closest('.filter-wrp').nextAll('.post-list').first().find('.post');

            if ($(this).hasClass('active')) {
                $('.filter-btn').removeClass('active');

                $(items).removeClass('inactive');

                if ($(this).data('cat') == 'show-all') {
                    history.replaceState({}, document.title, window.location.href.split('#')[0]);
                    $(items).removeClass('inactive');
                }
            } else {
                $('.filter-btn').removeClass('active');
                $(this).addClass('active');

                $(items).addClass('inactive');
                $('.post-list .post[data-cat*=' + $(this).attr('data-cat') + ']').removeClass('inactive');

                if ($(this).data('cat') == 'show-all') {
                    history.replaceState({}, document.title, window.location.href.split('#')[0]);
                    $(items).removeClass('inactive');
                }
            }

        });

    });

});